<div class="apply-one-style">
  <div class="site-width bg-dark">
    <div class="banner-list-items mx-1">
      <button type="button" class="banner-close" aria-label="Fermer" (click)="close(); (false)">
        <span aria-hidden="true">×</span>
      </button>
      <img src="{{ smartBannerImg }}" alt="logo Orange/Sosh" class="banner-img pl-1" />
      <div class="banner-text">
        <span class="pt-1 font-weight-bold">{{ 'smartbanner.label' | translate: { app: smartBannerBrand } }}</span>
        <a
          href="{{ smartBannerUrl }}"
          (click)="navigateToApp(); (false)"
          class="o-link-arrow o-link-small o-link-reverse"
          >{{ 'smartbanner.open' | translate }}<span class="sr-only">{{ 'smartbanner.open' | translate }}</span></a
        >
      </div>
    </div>
  </div>
</div>
